/**
 * Reduces the full "SELECT @@VERSION" banner text down to just "SQL Server <year>"
 * (e.g. "Microsoft SQL Server 2019 (RTM-CU18)..." -> "SQL Server 2019").
 * 
 * Handles:
 * - Full SELECT @@VERSION banners
 * - Standard strings like "SQL Server 2019", "SQL Server 2008 R2"
 * - Standalone years or build/version numbers
 */
export const formatSqlVersion = (raw) => {
  if (!raw || raw === "-") return "-";

  // Check for "SQL Server <year>" with optional "R2"
  const match = raw.match(/SQL Server (\d{4}(?:\s*R2)?)/i);
  if (match) {
    return `SQL Server ${match[1]}`;
  }

  // Check for standalone year
  const yearMatch = raw.match(/\b(2005|2008(?:\s*R2)?|2012|2014|2016|2017|2019|2022)\b/i);
  if (yearMatch) {
    return `SQL Server ${yearMatch[1]}`;
  }

  // Check for major version prefix (e.g. 15.0 -> 2019)
  const majorMatch = raw.match(/^(\d+)\./);
  if (majorMatch) {
    const majorMap = {
      '16': 'SQL Server 2022',
      '15': 'SQL Server 2019',
      '14': 'SQL Server 2017',
      '13': 'SQL Server 2016',
      '12': 'SQL Server 2014',
      '11': 'SQL Server 2012',
      '10': raw.includes('10.50') ? 'SQL Server 2008 R2' : 'SQL Server 2008',
      '9': 'SQL Server 2005',
    };
    if (majorMap[majorMatch[1]]) {
      return majorMap[majorMatch[1]];
    }
  }

  return raw;
};
